import {gql, useLazyQuery, useMutation} from '@apollo/client';
import {Box} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Panel} from '../../components/Panel/Panel';
import {useQueryParams} from '../../hooks/useQueryParams';
import {OneViewModelTypesEnum} from '../../schema-types/globalTypes';
import {
  GetNativeIdFromCuro,
  GetNativeIdFromCuroVariables,
} from '../../schema-types/GetNativeIdFromCuro';
import {GET_NATIVE_ID_FROM_CURO} from './TestHomepage';
import {ResetAccount, ResetAccountVariables} from '../../schema-types/ResetAccount';
import validateUUID from '../../utils/validateUUID';

export const TestAccountPage: React.FC = () => {
  const {accountCuroId} = useParams();
  const params = useQueryParams();
  const [loading, setLoading] = useState(true);
  const [onGetNative] = useLazyQuery<GetNativeIdFromCuro, GetNativeIdFromCuroVariables>(
    GET_NATIVE_ID_FROM_CURO
  );
  const [resetAccount] = useMutation<ResetAccount, ResetAccountVariables>(gql`
    mutation ResetAccount($accountId: UUID, $accountCuroId: UUID) {
      resetAccount(accountId: $accountId, accountCuroId: $accountCuroId) {
        account {
          id
        }
        errors
        ok
      }
    }
  `);

  useEffect(() => {
    async function go() {
      if (process.env.NODE_ENV !== 'production' && params.get('reset')) {
        resetAccount({
          variables: {
            accountCuroId: validateUUID(accountCuroId),
          },
        })
          .then(({data}) => {
            const goTo = params.get('goTo') || 'reviews';
            if (data?.resetAccount?.account?.id) {
              navigate({
                pathname: `/account/${data?.resetAccount?.account?.id}/${goTo}`,
              });
            }
          })
          .finally(() => setLoading(false));
      } else {
        const curoId = validateUUID(accountCuroId);
        if (!curoId) {
          setLoading(false);
          return;
        }
        onGetNative({
          variables: {
            curoId,
            modelName: OneViewModelTypesEnum.ACCOUNT,
          },
        })
          .then(({data}) => {
            const goTo = params.get('goTo') || 'reviews';
            if (data?.nativeId) {
              navigate({
                pathname: `/account/${data?.nativeId}/${goTo}`,
              });
            }
          })
          .finally(() => setLoading(false));
      }
    }
    go();
  }, [accountCuroId]);
  const navigate = useNavigate();
  return (
    <div>
      <Panel title="Account test setup">
        {loading ? <Box>Setting up test</Box> : null}
      </Panel>
    </div>
  );
};
